import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/pricingBlock.module.css';

import { Wrapper } from '@klv/utils/wrapper';
import Buttons from '@klv/molecules/buttons';
import PlanCard from './plan-card';

export const PricingBlock = () => {
  const buttons = [
    {
      text: 'Sign up',
      url: '/sign-up',
    },
    {
      text: 'Build my plan',
      url: '/pricing',
    },
  ];

  const planCardContent = {
    name: 'Email + SMS',
    price: 60,
    credits: 1250,
    emailSends: 15000,
    contacts: 0,
    selectedLocale: 'US',
    featuresList: [
      {
        listText: 'Customer profiles with all-time data',
        listIcon: 'checkmark',
      },
      {
        listText: '350+ built-in integrations',
        listIcon: 'checkmark',
      },
      {
        listText: 'Built-in reporting dashboards',
        listIcon: 'checkmark',
      },
      {
        listText: 'Generative AI to create content fast',
        listIcon: 'checkmark',
      },
    ],
  };

  return (
    <Wrapper
    contained={false}
    inlinePadding={true}
      customPadding={{ customPaddingBottom: 'md', customPaddingTop: 'md' }}
      fadeIn={0}
      backgroundColor={'cotton'}
    >
    <div className={generateClassName([styles.pricingSection, 'grid'])}>
        {/* Left: Text content */}
        <div className={styles.pricingText}>
          <h2 className={styles.heading}>Flexible pricing for B2C brands</h2>
          <p className={styles.description}>
            Visit the pricing page to see all the products and features available to help you create smarter customer journeys and longer-lasting relationships.
          </p>
          <div className={generateClassName([styles.pricingCardMobile])}>
            <PlanCard {...planCardContent} />
        </div>
          <ul className={styles.featuresList}>
            <li>Email marketing</li>
            <li>SMS marketing</li>
            <li>Reviews</li>
            <li>Marketing Analytics</li>
            <li>Advanced Klaviyo<wbr /> Data Platform</li>
            <li>Customer Hub</li>
            <li>Templates</li>
            <li>Automated flows</li>
            <li>Segmentation</li>
          </ul>
          <div className={styles.pricingActions}>
          {buttons && buttons.length > 0 && (
            <Buttons
              buttons={buttons}
              buttonColor='dark'
              variants={buttons.length === 1 ? ['secondary'] : ['primary', 'secondary']}
              />
          )}
          </div>
        </div>
        {/* Right: Pricing card */}
      <div className={generateClassName([styles.pricingCardDesktop])}>
          <PlanCard {...planCardContent} />
        </div>
    </div>
    </Wrapper>
  );
};
